import { combineLatest, fromEvent, map, skip, startWith } from "rxjs";

export default class ZipInput {
  constructor() {
    this.valueInput = '';
    this.isInternationalInput  = false;
    this.errorMessageId = 'nhs_ErrorForipCodeReg';
    this.idForOutside = 'livesOutside';
    this.idForZip = 'postalCode';
    this.errorCssClass = 'error';
    this.errorMessage = `<span id="${this.errorMessageId}" class="form__error zip__error" hidden>
                           Please enter a valid zip code
                         </span>`;
    this.labelForOutside = `<label for="${this.idForOutside}" class="form__text">Outside U.S.</label>`;
    this.labelForZipCode = `<label for="${this.idForZip}" class="visuallyhidden">Zip Code</label>`;
    this.pattern = '^\\d{5}(-\\d{4})?$';
    this.matchingPattern = new RegExp(this.pattern);
  }

  set isInternational(newValue){
    this.isInternationalInput = !!newValue;
  }

  get isInternational(){
    return this.isInternationalInput;
  }

  set value(newValue){
    this.valueInput = newValue;
  }

  get value(){
    return this.valueInput;
  }

  bindEvents() {
    this.getOutsideUsNode().addEventListener('change', this.onOutsideUsChanged.bind(this));
  }

  getHtml() {
    return `<div>
              ${this.labelForZipCode}
              <input data-qa="zip-input" data-segment-identity-data="zip" id="${this.idForZip}" class="form__input form__zip" 
                placeholder="*Zip Code" name="${this.idForZip}" autocomplete="postal-code" 
                maxlength="10" type="tel" required
                ${this.isInternational ? 'disabled="true"' : `value="${this.value}"`} data-form-zip-input></input>
              ${this.errorMessage}
            </div>
            <div class="field--checkbox">
            <input data-qa="outside-us-input" data-segment-identity-data="outside_us" type="checkbox" id="${this.idForOutside}" 
                name="${this.idForOutside}" class="form__checkbox"
                ${this.isInternational ? 'checked="checked"' : ''} data-form-lives-outside-input></input>
              ${this.labelForOutside}
            </div>`;
  }

  getOutsideUsNode() {
    return document.getElementById(this.idForOutside);
  }

  getZipNode() {
    return document.getElementById(this.idForZip);
  }

  /**
   * getOnChangeEvent: On inputs change map their values to the storage properties.
   */
  getOnChangeEvent() {
    const outSideNode = this.getOutsideUsNode();
    const zipNode = this.getZipNode();
    const onOutSideChange$ = fromEvent(outSideNode, 'change').pipe(
      map((event) => event.target),
      startWith(outSideNode)
    );
    const onZipChange$ = fromEvent(zipNode, 'change').pipe(
      map((event) => event.target),
      startWith(zipNode)
    );
    return combineLatest([onZipChange$, onOutSideChange$]).pipe(
      map(([zipInput, livesOutsideInput]) => ({
        zip: zipInput.value,
        livesOutside: livesOutsideInput.checked,
      })),
      skip(1)
    );
  }

  isOutsideUs() {
    return this.getOutsideUsNode().checked;
  }

  isValidZipCode() {
    const node = this.getZipNode();
    return this.matchingPattern.test(node.value?.trim());
  }

  onOutsideUsChanged(event) {
    const node = this.getZipNode();

    if (event.currentTarget.checked) {
      node.setAttribute('disabled', true);
      node.value = '';
      this.setValidState(node);
    } else {
      node.removeAttribute('disabled', true);
    }
  }

  setInvalidState() {
    const errorMessage = document.getElementById(this.errorMessageId);
    const node = this.getZipNode();

    node.setAttribute('aria-invalid', true);
    node.classList.add(this.errorCssClass);
    errorMessage.removeAttribute('hidden');
  }

  setValidState() {
    const errorMessage = document.getElementById(this.errorMessageId);
    const node = this.getZipNode();

    node.removeAttribute('aria-invalid');
    node.classList.remove(this.errorCssClass);
    errorMessage.setAttribute('hidden', true);
  }

  validate() {
    const isOutsideUs = this.isOutsideUs();
    const isValidZipCode = this.isValidZipCode();
    const isValid = isOutsideUs || isValidZipCode;
    
    return new Promise((resolve) => {
      if (isValid) {
        this.setValidState();
        resolve(true);
      } else {
        this.setInvalidState();
        resolve(false);
      }
    });
  }
}
